import React from 'react';
import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import FormField from '../../../forms/FormField';

const required = value => value ? undefined : 'Required';
const requiredNumber = value => !value && value !== 0 ? 'Required' : undefined;

const checkError = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { message } = json || {};

  if (!message) return;

  switch (message) {
    default:
      return 'Generic';
  }
};

const filterMonth = ({ value, label }, search) => {
  const l = (label || '').trim().toLowerCase();
  const compare = (search || '').toLowerCase();
  if ((l || '').startsWith(compare)) return true;
  if (isNaN(search)) return false;
  try {
    const num = parseInt(search);
    return num === value + 1;
  } catch (err) {
    return false;
  }
};

const EditBirthdayForm = (
  {
    handleSubmit,
    submitting,
    errorSubmit,
    toggle
  }
) => {
  const formSubmitError = checkError(errorSubmit);

  return (
    <div className="row">
      <div className="col-md-6">
        <p className="account-info-block last">
          Shipper will not leave wine without an adult signature. Please make sure an adult is available to sign for delivery.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-6">
              <Field
                name="dob_month"
                type="text"
                component={FormField.SelectReact}
                placeholder="Birth Month"
                filterOption={filterMonth}
                validate={[requiredNumber]}
                menuPortalTarget={document.body}
                options={[
                  { value: 0, label: 'January' },
                  { value: 1, label: 'February' },
                  { value: 2, label: 'March' },
                  { value: 3, label: 'April' },
                  { value: 4, label: 'May' },
                  { value: 5, label: 'June' },
                  { value: 6, label: 'July' },
                  { value: 7, label: 'August' },
                  { value: 8, label: 'September' },
                  { value: 9, label: 'October' },
                  { value: 10, label: 'November' },
                  { value: 11, label: 'December' }
                ]}
              />
            </div>
            <div className="col-3">
              <div className="form-group">
                <Field
                  name="dob_day"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Day"
                  menuPortalTarget={document.body}
                  validate={[required]}
                  options={Array.from(Array(31), (_, i) => ({
                    value: i + 1,
                    label: i + 1
                  }))}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="form-group">
                <label className="sr-only">year</label>
                <Field
                  name="dob_year"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Year"
                  menuPortalTarget={document.body}
                  validate={[required]}
                  options={Array.from(Array(90), (_, i) => ({
                    value: new Date().getFullYear() - 21 - i,
                    label: new Date().getFullYear() - 21 - i
                  }))}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-6">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={submitting}
              >
                Submit
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                onClick={() => toggle('birthday')}
                disabled={submitting}
              >
                Cancel
              </button>
            </div>
          </div>
          {formSubmitError === 'Generic' &&
            <div className="form-row">
              <span style={{ color: '#dc3545', marginLeft: '10px' }}>
                An error occured trying edit Birthday.
              </span>
            </div>}
        </form>
      </div>
    </div>
  );
};

const formName = 'edit-birthday-form';

const mapState = state => {};

const form = reduxForm({ form: formName, enableReinitialize: true })(
  EditBirthdayForm
);
export default connect(mapState)(form);
